import React, { useContext, useState } from 'react'

export const ThemeContext = React.createContext()
export const ThemeUpdateContext = React.createContext()

export function useTheme() {
    return useContext(ThemeContext)
}

export function useThemeUpdate() {
    return useContext(ThemeUpdateContext)
}

export function ThemeProvider({ children }) {
    const defaultTheme = window.localStorage.getItem('defaultTheme') === "true"
    const [darkTheme, setDarkTheme] = useState(defaultTheme || false)

    function toggleDarkTheme() {
        setDarkTheme(prev => {
            window.localStorage.setItem('defaultTheme', !prev)
            return !prev
        })
    }

    return (
        <ThemeContext.Provider value={darkTheme}>
            <ThemeUpdateContext.Provider value={toggleDarkTheme}>
                {children}
            </ThemeUpdateContext.Provider>
        </ThemeContext.Provider>
    )
}